<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">
       <span>
        <mat-form-field matTooltip="Select a Asset from the list" [matTooltipDisabled]="disabledTooltip(this.asset)">
          <mat-label i18n="@@type.AssetMaintenance.asset">Asset</mat-label>
          <mat-select formControlName="asset" id="asset"              
              [ngModel]="item.asset" #asset placeholder="Asset" [disabled]="true"  [compareWith]="assetCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let asset of assetSelectionList" [value]="asset">
              {{assetDisplay(asset)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Maintenance Type from the list" [matTooltipDisabled]="disabledTooltip(this.maintenanceType)"  class="crud-item-input-wider">
          <mat-label i18n="@@type.AssetMaintenance.maintenanceType">Maintenance Type</mat-label>
          <mat-select formControlName="maintenanceType" id="maintenanceType"              
              (ngModelChange)="maintenanceTypeChanging($event)" [(ngModel)]="item.maintenanceType"              
              (ngModelChange)="maintenanceTypeChanged($event)" #maintenanceType              
              placeholder="Maintenance Type">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let maintenanceType of maintenanceTypeSelectionList" [value]="maintenanceType.code">
              {{maintenanceType.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </div>
    <mat-divider></mat-divider>
  
    <div class="crud-item-section">
    
      <span>
        <mat-form-field matTooltip="Maintenance By" [matTooltipDisabled]="disabledTooltip(this.maintenanceBy)">
          <mat-label i18n="@@type.AssetMaintenance.maintenanceBy">Maintenance By</mat-label>
          <input matInput formControlName="maintenanceBy" id="maintenanceBy"              
              (ngModelChange)="maintenanceByChanging($event)" [(ngModel)]="item.maintenanceBy"              
              (ngModelChange)="maintenanceByChanged($event)" #maintenanceBy              
              maxlength="255" placeholder="Maintenance By">
        </mat-form-field>
      </span>
      <span>
        <mat-form-field matTooltip="Maintenance Date" [matTooltipDisabled]="disabledTooltip(this.maintenanceDate)">
          <mat-label i18n="@@type.AssetMaintenance.maintenanceDate">Maintenance Date</mat-label>
          <input matInput formControlName="maintenanceDate" id="maintenanceDate"              
              (ngModelChange)="maintenanceDateChanging($event)" [(ngModel)]="item.maintenanceDate"              
              (ngModelChange)="maintenanceDateChanged($event)" #maintenanceDate              
              [matDatepicker]="maintenanceDateDatePicker" placeholder="Maintenance Date">
          <mat-datepicker-toggle matSuffix [for]="maintenanceDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #maintenanceDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Created By" [matTooltipDisabled]="disabledTooltip(this.createdBy)">
          <mat-label i18n="@@type.AssetMaintenance.createdBy">Created By</mat-label>
          <input matInput formControlName="createdBy" id="createdBy"              
              (ngModelChange)="createdByChanging($event)" [(ngModel)]="item.createdBy"         
              (ngModelChange)="createdByChanged($event)" #createdBy              
              maxlength="255" placeholder="Created By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Created Date" [matTooltipDisabled]="disabledTooltip(this.createdDate)">
          <mat-label i18n="@@type.AssetMaintenance.createdDate">Created Date</mat-label>
          <input matInput formControlName="createdDate" id="createdDate"              
              (ngModelChange)="createdDateChanging($event)" [(ngModel)]="item.createdDate"             
              (ngModelChange)="createdDateChanged($event)" #createdDate              
              [matDatepicker]="createdDateDatePicker" placeholder="Created Date">
          <mat-datepicker-toggle matSuffix [for]="createdDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>
    </div>
  
    <mat-divider></mat-divider>
    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Comments" [matTooltipDisabled]="disabledTooltip(this.comments)" class="textarea-full-wide">
          <mat-label i18n="@@type.AssetMaintenance.comments">Comments</mat-label>
          <textarea matInput formControlName="comments" id="comments" class="field-full-width"          
              (ngModelChange)="commentsChanging($event)" [(ngModel)]="item.comments"              
              (ngModelChange)="commentsChanged($event)" #comments              
              maxlength="1000" placeholder="Comments"></textarea>
        </mat-form-field>
      </span>
    </div>

  </form>
</div>